"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _formatted_number = require("./global_components/formatted_number");

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeesCardDataPoint = function (_React$PureComponent) {
  _inherits(FeesCardDataPoint, _React$PureComponent);

  function FeesCardDataPoint() {
    _classCallCheck(this, FeesCardDataPoint);

    return _possibleConstructorReturn(this, (FeesCardDataPoint.__proto__ || Object.getPrototypeOf(FeesCardDataPoint)).apply(this, arguments));
  }

  _createClass(FeesCardDataPoint, [{
    key: "render",
    value: function render() {
      var formattedValue = !(0, _ramda.isNil)(this.props.numberFormat) ? _react2.default.createElement(_formatted_number2.default, { numberFormat: this.props.numberFormat, value: this.props.value }) : this.props.value;

      var labelColClass = this.props.indent ? "col-xs-5 col-sm-5 col-md-4 col-lg-4 col-xlg-4 col-xs-offset-1 col-sm-offset-1 col-md-offset-1 col-xlg-offset-1 col-lg-offset-1 " : "col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xlg-5 ";

      return _react2.default.createElement(
        "div",
        { "data-testid": "portfolio-row", className: "portfolio-override-bold row padding-vertical-5 margin-all-0 row-divider" },
        _react2.default.createElement(
          "div",
          { "data-testid": "fees-label-column", className: "text-left padding-left-0 category " + labelColClass },
          _react2.default.createElement(
            "span",
            { "data-testid": this.props.dataTest + "-label" },
            this.props.label
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "text-right category padding-right-0 col-xs-6 col-sm-6 col-md-7 col-lg-7 col-xlg-7" },
          _react2.default.createElement(
            "span",
            { "data-testid": this.props.dataTest },
            formattedValue
          )
        )
      );
    }
  }]);

  return FeesCardDataPoint;
}(_react2.default.PureComponent);

exports.default = FeesCardDataPoint;